module.exports = __webpack_public_path__ + "img/arrow.d5e81b91.svg";